import React, { useCallback, useState } from "react";
import Cropper from "react-easy-crop";
import { getCroppedImageBlob } from "../helpers/cropImage";
import "./PhotoCropModal.css";

// Aspect ratio of an ID-1 card (e.g. a driving license), width / height.
const ID_CARD_ASPECT = 85.6 / 53.98;

export default function PhotoCropModal({ imageSrc, mimeType, title = "Foto zuschneiden", onCancel, onConfirm }) {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState(null);

  const handleCropComplete = useCallback((_, areaPixels) => {
    setCroppedAreaPixels(areaPixels);
  }, []);

  const handleConfirm = async () => {
    if (!croppedAreaPixels) return;
    setProcessing(true);
    setError(null);
    try {
      const blob = await getCroppedImageBlob(imageSrc, croppedAreaPixels, mimeType || "image/jpeg");
      onConfirm(blob);
    } catch (err) {
      console.error("Zuschneiden fehlgeschlagen:", err);
      setError("Zuschneiden fehlgeschlagen. Bitte erneut versuchen.");
    } finally {
      setProcessing(false);
    }
  };

  return (
    <div className="photo-crop-overlay" onClick={onCancel}>
      <div className="photo-crop-modal" onClick={(e) => e.stopPropagation()}>
        <div className="photo-crop-header">
          <h2>{title}</h2>
          <button type="button" className="photo-crop-close" onClick={onCancel} aria-label="Schließen">×</button>
        </div>

        <div className="photo-crop-area">
          <Cropper
            image={imageSrc}
            crop={crop}
            zoom={zoom}
            aspect={ID_CARD_ASPECT}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={handleCropComplete}
          />
        </div>

        <div className="photo-crop-controls">
          <label className="photo-crop-zoom-label">
            🔍
            <input
              type="range"
              min={1}
              max={3}
              step={0.01}
              value={zoom}
              onChange={(e) => setZoom(Number(e.target.value))}
            />
          </label>
        </div>

        {error && <p className="photo-crop-error">{error}</p>}

        <div className="photo-crop-actions">
          <button type="button" className="btn btn-secondary" onClick={onCancel} disabled={processing}>
            Abbrechen
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleConfirm}
            disabled={processing || !croppedAreaPixels}
          >
            {processing ? "Wird verarbeitet…" : "✔ Übernehmen"}
          </button>
        </div>
      </div>
    </div>
  );
}
